import { isValidShippingForm } from '../custom-store/shipping-form-validation';
export const isValidPFIShippingForm = values => {
  return isValidShippingForm(values, false);
};